import Modal from 'components/Modal';
import Table from 'components/Table';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useAsync } from 'react-use';
import services from 'services';
import actions from 'state/actions';
import selectors from 'state/selectors';
import utils from 'utils';

const SelfValidate = () => {
  const dispatch = useDispatch();
  const t = utils.intl.useTranslator();
  const [rows, setRows] = useState([]);
  const [currentRow, setCurrentRow] = useState<{ [key: string]: any } | null>(null);
  const idProgram = useSelector(selectors.app.getProgramCode) || -1;
  const idUser = useSelector(selectors.user.getIdUser) || -1;
  const records = useSelector(selectors.documents.selectAllActiveDocuments);
  const idCompany = records[0]?.idCompany || -1;
  const history = useHistory();

  const onConfirm = async () => {
    try {
      if (records.length > 0 && currentRow !== null && currentRow.hasOwnProperty('idUser')) {
        const nProtocols = records.map((rec: any) => rec.protocol);
        await services.selfValidate({ idUserTo: currentRow.idUser, idUser, idProgram, protocols: nProtocols });
        utils.app.notify('success', t('self-validate success'));
        dispatch(actions.modal.closeModal());
        dispatch(actions.documents.removeRows(nProtocols));
        if (utils.documents.isOpenDocumentView()) dispatch(actions.documents.openNextDocument(history));
        return;
      }
      utils.app.notify('fail', t('self-validate-error-missing-row'));
      throw new Error('Error on self validate, missing row');
    } catch (e) {
      console.error(e);
    }
  };

  useAsync(async () => {
    try {
      const { data } = await services.getAllowedUsers({ idUser, idCompany, idProgram });
      setRows(data);
    } catch (e) {
      console.error(e);
    }
  }, []);

  const columns = [
    {
      accessor: 'username',
      Header: t('User'),
    },
    {
      accessor: 'name',
      Header: t('Name'),
    },
    {
      accessor: 'role',
      Header: t('Role'),
    },
  ];

  return (
    <>
      <Modal.Header title={t('self-validate-header')} subtitle={t('self-validate-subtitle')} />
      <Modal.Content>
        <Table
          id="self-validate-table"
          onSelection={(row: {}[]) => setCurrentRow(row[0])}
          hasPagination
          hasSort
          hasSelection
          hasFilter
          columns={columns}
          rows={rows}
        />
      </Modal.Content>
      <Modal.Footer confirmDisabled={currentRow === null} confirmAction={() => onConfirm()} />
    </>
  );
};

export default SelfValidate;
